import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import LogoutButton from '../../auth/LogoutButton';
import './Header.css';

const Header = ({ onMenuToggle, showMobileMenu = false }) => {
  const { isAuthenticated } = useAuth0();
  return (
    <header className="app-header">
      <div className="container">
        <div className="header-content">
          <div className="logo-section">
            <img
              src="/next-generation-logo.svg"
              alt="Next Generation"
              className="logo"
            />
          </div>
          <div className="header-title">
            <h1>Pre-Onboarding Data Collection</h1>
            <p>Complete your application to get started</p>
          </div>
          <div className="header-actions">
            {showMobileMenu && (
              <button
                className="mobile-menu-btn"
                onClick={onMenuToggle}
                aria-label="Toggle section menu"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span className="menu-text">Sections</span>
              </button>
            )}

            {isAuthenticated && <LogoutButton />}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
